<script>
  export let prevAlt;
  export let nextAlt;
  import SwiperNavPrev from './icon/PrevAlt.svelte';
  import SwiperNavNext from './icon/NextAlt.svelte';
</script>

<button class="swiper-nav swiper-nav--prev" bind:this={prevAlt}>
  <SwiperNavPrev />
</button>
<button class="swiper-nav swiper-nav--next" bind:this={nextAlt}>
  <SwiperNavNext />
</button>

<style lang="scss">
  .swiper-nav {
    padding: 0;

    cursor: default;
    position: absolute;
    z-index: 2;
    top: 40%;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 6.1rem;
    height: 6.1rem;

    transition: all 0.2s;

    :global path {
      stroke: var(--royal);

      transition: all 0.2s;
    }

    &--prev {
      left: 0;

      @include resp-max('m') {
        left: -3rem;
      }
    }

    &--next {
      right: 0;
      @include resp-max('m') {
        right: -3rem;
      }
    }

    :global &.swiper-button-disabled {
      path {
        stroke: var(--grey-2);
      }
    }

    &:not(.swiper-button-disabled) {
      cursor: pointer;

      &:hover {
        :global path {
          stroke: var(--aqua-1);
        }
      }
    }

    :global &.swiper-button-lock {
      display: none;
    }
  }
</style>
